import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useEffect } from 'react';
import ReactModal from 'react-modal';
import { CloseButton, CloseIcon } from './Modal.styles.js';

var _excluded = ["children", "closeTimeoutMS", "hasMegaForm", "isShowing", "onClose", "size", "noExit"];
var Modal = function Modal(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$closeTimeoutMS = _ref.closeTimeoutMS,
    closeTimeoutMS = _ref$closeTimeoutMS === void 0 ? 300 : _ref$closeTimeoutMS,
    _ref$hasMegaForm = _ref.hasMegaForm,
    hasMegaForm = _ref$hasMegaForm === void 0 ? false : _ref$hasMegaForm,
    _ref$isShowing = _ref.isShowing,
    isShowing = _ref$isShowing === void 0 ? false : _ref$isShowing,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? null : _ref$onClose,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    _ref$noExit = _ref.noExit,
    noExit = _ref$noExit === void 0 ? false : _ref$noExit,
    props = _objectWithoutProperties(_ref, _excluded);
  // Setting the app element is required for accessibility reasons
  // http://reactcommunity.org/react-modal/accessibility/
  useEffect(function () {
    ReactModal.setAppElement('body');
  }, []);
  return /*#__PURE__*/React__default.createElement(ReactModal, _extends({
    closeTimeoutMS: closeTimeoutMS,
    isOpen: isShowing,
    o: true,
    onRequestClose: !noExit && onClose,
    className: "ReactModal__CustomOverlay leshen-modal leshen-modal-".concat(size, " ").concat(hasMegaForm ? 'contains-mega-form' : ''),
    overlayClassName: "ReactModal__CustomContent"
  }, props), !noExit && /*#__PURE__*/React__default.createElement(CloseButton, {
    "aria-label": "Close",
    tabIndex: "0",
    "data-testid": "modal-close",
    onClick: onClose,
    className: "close",
    hasMegaForm: hasMegaForm
  }, /*#__PURE__*/React__default.createElement(CloseIcon, {
    className: "button",
    height: 20,
    width: 20
  })), children);
};
var Modal$1 = Modal;

export { Modal$1 as default };
//# sourceMappingURL=index.js.map
